const _userIcon = document.getElementsByClassName('js--mobile-user')[0];
const _dropdown = document.getElementsByClassName('js--user-dropdown')[0];

function toggleMobileAccount(action) {
    if (action === 'close') {
        _userIcon.classList.remove('db-nav__user--user-active');
        _dropdown.classList.remove('db-nav__user--dropdown-active');
        return;
    }

    _userIcon.classList.toggle('db-nav__user--user-active');
    _dropdown.classList.toggle('db-nav__user--dropdown-active');
}

export function closeMobileAccount() {
    if (_dropdown.classList.contains('db-nav__user--dropdown-active')) {
        toggleMobileAccount('close');
    }
}

function handleAccountIconClick(e) {
    e.preventDefault();
    document
        .getElementsByClassName('js--nav-account')[0]
        .classList.toggle('db-nav--account-active');
}

function init() {
    const _searchIcon = document.getElementsByClassName('js--mobile-search')[0];
    // const _mobileSearchClose = document.getElementsByClassName('js--mobile-search-close')[0]
    const mobileWidthMax = 960;

    _userIcon.addEventListener('click', (e) => {
        e.preventDefault();

        if (window.innerWidth <= mobileWidthMax) {
            toggleMobileAccount();
        }
    });

    _searchIcon.addEventListener('click', (e) => {
        e.preventDefault();

        if (window.innerWidth <= mobileWidthMax) {
            closeMobileAccount();
            // toggleMobileSearch()
        }
    });

    // _mobileSearchClose.addEventListener('click', (e) => {
    //   e.preventDefault()
    // toggleMobileSearch('close')
    // })

    document
        .getElementsByClassName('js--mobile-user')[0]
        .addEventListener('click', (e) => handleAccountIconClick(e));
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/dealer-portal-navigation.js